import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/Pawn/List/SellOnConsignmen/data/data";
import useColumns from "pages/Pawn/List/SellOnConsignmen/columns/mainColumns";
import useColumnsTwo from "pages/Pawn/List/SellOnConsignmen/columns/subColumns";
import Modal from "components/Modal/Pawn/Create/ModalCreatePawn";
import ModalRedeem from "components/Modal/Pawn/Create/ModalRedeem";
import ModalInterest from "components/Modal/Pawn/Create/ModalInterest";
import ViewModal from "components/Modal/Pawn/View/ViewPawn";
import SearchBar from "components/TableExplanded/SearchBar";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SaveIcon from "@mui/icons-material/Save";

import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import api from "_api";
import Swal from "sweetalert2";
import ModalPawnForm from "components/Modal/Pawn/Print/ModalPawnForm";
import ModalConfirm from "components/Modal/ModalConfirm";
import RepossessedImg from "../../../../assets/images/cooldown.png";

const SellOnConsignmen = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalRedeemOpen, setModalRedeemOpen] = useState(false);
  const [isModalInterest, setModalInterest] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [rowID, setRowID] = useState(null);

  const fetchProductData = async (filters) => {
    try {
      console.log("filter", filters);
      const { data, isStatus, total } = await api.pawn.getOrderV2({
        ...filters,
        page: filters.page || page + 1 || 1,
        limit: filters.limit || rowsPerPage || 10,
      });
      if (isStatus) {
        setFetchData(data);
        setDataLength(total); // Set the total data length for pagination
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  const updateOrder = async (values) => {
    try {
      const { data, isStatus } = await api.pawn.updateOrderPawn(values);
      // console.log("data22556633", values);
      if (isStatus)
        fetchProductData({
          qrcode: "",
          customerName: "",
          idCard: "",
          pawnPrice: "",
          createdDate: "",
          dueDate: "",
          page: 1,
          limit: rowsPerPage,
        });
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData(
      {
        qrcode: searchQuery,
        customerName: "",
        idCard: "",
        pawnPrice: "",
        createdDate: "",
        dueDate: "",
      },
      page + 1,
      rowsPerPage
    );
  }, [searchQuery, page, rowsPerPage]);

  // console.log("data display new data", fetchData);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleModalRedeemOpen = () => {
    setModalRedeemOpen(!isModalRedeemOpen);
    if (selectedProduct && isModalRedeemOpen) setProduct(null);
  };

  const handleModalInterest = () => {
    setModalInterest(!isModalInterest);
    if (selectedProduct && isModalInterest) setProduct(null);
  };

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const [isModalPrint, setIsModalPrint] = useState(false);

  const handleModalPrint = () => {
    setIsModalPrint(!isModalPrint);
  };

  //ใช้สำหรับ ส่งไปยังสินค้าหลุดจำนำ

  const handleAlertModal = (values) => {
    setRowID(values);
    setIsAlertModalOpen(true);
  };

  //ใช้สำหรับ ปรับต้นทุนและส่งไปสินค้าหลุดจำนำ
  const handleAlertModalPawn = (values) => {
    Swal.fire({
      title: "ปรับต้นทุนสินค้า",
      text: "ระบบจะทำการปรับต้นทุนสินค้าโดยอัตโนมัติ",
      // icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0066FF",
      cancelButtonColor: "#0066FF",
      reverseButtons: true,
      confirmButtonText: "ตกลง",
      cancelButtonText: "ยกเลิก",
      customClass: {
        confirmButton: "confirm-rounded-button",
        cancelButton: "outlined-button",
        container: "swal2-container-custom", // Add custom class for container
      },
      // didOpen: () => {
      //   // Set z-index in didOpen to ensure it's applied after dialog is rendered
      //   document.querySelector(".swal2-container-custom").style.zIndex = 1500; // or a higher value
      // },
      // iconHtml:
      //   '<svg width="150" height="150" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.4339 0.666016C36.3209 0.666016 46.7673 11.1123 46.7673 23.9993C46.7673 36.8863 36.3209 47.3327 23.4339 47.3327C10.5469 47.3327 0.100586 36.8863 0.100586 23.9993C0.100586 11.1123 10.5469 0.666016 23.4339 0.666016ZM23.4339 5.33268C18.4832 5.33268 13.7353 7.29934 10.2346 10.8C6.73391 14.3007 4.76725 19.0486 4.76725 23.9993C4.76725 28.9501 6.73391 33.698 10.2346 37.1987C13.7353 40.6994 18.4832 42.666 23.4339 42.666C28.3846 42.666 33.1326 40.6994 36.6332 37.1987C40.1339 33.698 42.1006 28.9501 42.1006 23.9993C42.1006 19.0486 40.1339 14.3007 36.6332 10.8C33.1326 7.29934 28.3846 5.33268 23.4339 5.33268ZM23.4339 30.9993C24.0528 30.9993 24.6462 31.2452 25.0838 31.6828C25.5214 32.1203 25.7673 32.7138 25.7673 33.3327C25.7673 33.9515 25.5214 34.545 25.0838 34.9826C24.6462 35.4202 24.0528 35.666 23.4339 35.666C22.8151 35.666 22.2216 35.4202 21.784 34.9826C21.3464 34.545 21.1006 33.9515 21.1006 33.3327C21.1006 32.7138 21.3464 32.1203 21.784 31.6828C22.2216 31.2452 22.8151 30.9993 23.4339 30.9993ZM23.4339 9.99935C24.0528 9.99935 24.6462 10.2452 25.0838 10.6828C25.5214 11.1204 25.7673 11.7138 25.7673 12.3327V26.3327C25.7673 26.9515 25.5214 27.545 25.0838 27.9826C24.6462 28.4202 24.0528 28.666 23.4339 28.666C22.8151 28.666 22.2216 28.4202 21.784 27.9826C21.3464 27.545 21.1006 26.9515 21.1006 26.3327V12.3327C21.1006 11.7138 21.3464 11.1204 21.784 10.6828C22.2216 10.2452 22.8151 9.99935 23.4339 9.99935Z" fill="#ED4040"/></svg>',
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log("Alert");
        // updateOrder(values);
      }
    });
  };

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen,
    handleModalRedeemOpen,
    handleModalInterest,
    handleAlertModal,
    handleAlertModalPawn,
    handleModalPrint
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  // const filteredData = useMemo(() => {
  //   if (!searchQuery) return data; // If no search query, return all data

  //   return data.filter((row) => {
  //     return visibleColumns.some((column) => {
  //       const cellValue = row[column.accessor]?.toString()?.toLowerCase();
  //       return cellValue && cellValue.includes(searchQuery.toLowerCase());
  //     });
  //   });
  // }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
      setSearchQuery(query); // Update searchQuery with the search term
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0); // Reset page when search changes
  };

  const handleClear = () => {
    setSearchTerm("");
    setSearchQuery("");
    setPage(0);
    fetchProductData({
      qrcode: "",
      customerName: "",
      idCard: "",
      pawnPrice: "",
      createdDate: "",
      dueDate: "",
      page: 1,
      limit: rowsPerPage,
    });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // console.log("searchTerm", searchTerm);

  const handleExportExcel = async () => {
    await api.pawn
      .exportExcelOrderPawn()
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "order_pawn.xlsx"; // Default กรณีไม่มีชื่อไฟล์จาก API

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+?)"?$/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
      });
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            รายการขายฝาก
          </Typography>
          <Grid display={"flex"} style={{ gap: "8px" }}>
            <GradientButtonOutline
              onClick={handleExportExcel}
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>
                ส่งออก Excel
              </Typography>
              <SaveIcon fontSize="medium" />
            </GradientButtonOutline>
            <GradientButton
              onClick={handleModalOpen}
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "48px",
              }}
            >
              <Typography style={{ marginRight: "8px" }}>ขายฝาก</Typography>
              <AddCircleIcon fontSize="medium" />
            </GradientButton>
          </Grid>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        handleClear={handleClear}
        fetchData={fetchData}
        handleSearchClick={(filters) => {
          console.log("filter>>>>", filters);
          fetchProductData({
            qrcode: filters.order_code || "",
            idCard: filters.idcard || "",
            customerName: filters.customer_name || "",
            pawnPrice: filters.sum_product_total_price || "",
            createdDate: filters.created_at || "",
            page: 1,
            limit: rowsPerPage,
          });
        }}
        QRCode={false}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        setDataLength={setDataLength}
      />
      <CustomPagination
        count={dataLength}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        // fetchProductData={fetchProductData}

        fetchProductData={() =>
          fetchProductData({
            qrcode: "",
            customerName: "",
            idCard: "",
            pawnPrice: "",
            createdDate: "",
            dueDate: "",
            page: 1,
            limit: rowsPerPage,
          })
        }
      />
      <ModalPawnForm
        open={isModalPrint}
        onClose={handleModalPrint}
        selectedProduct={selectedProduct}
      />
      <ModalRedeem
        open={isModalRedeemOpen}
        onClose={handleModalRedeemOpen}
        selectedProduct={selectedProduct}
        // fetchProductData={fetchProductData}

        fetchProductData={() =>
          fetchProductData({
            qrcode: "",
            customerName: "",
            idCard: "",
            pawnPrice: "",
            createdDate: "",
            dueDate: "",
            page: 1,
            limit: rowsPerPage,
          })
        }
      />
      <ModalInterest
        open={isModalInterest}
        onClose={handleModalInterest}
        selectedProduct={selectedProduct}
        // fetchProductData={fetchProductData}

        fetchProductData={() =>
          fetchProductData({
            qrcode: "",
            customerName: "",
            idCard: "",
            pawnPrice: "",
            createdDate: "",
            dueDate: "",
            page: 1,
            limit: rowsPerPage,
          })
        }
      />
      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        selectedProduct={viewProduct}
        // fetchProductData={fetchProductData}
        fetchProductData={() =>
          fetchProductData({
            qrcode: "",
            customerName: "",
            idCard: "",
            pawnPrice: "",
            createdDate: "",
            dueDate: "",
            page: 1,
            limit: rowsPerPage,
          })
        }
      />
      <ModalConfirm
        open={isAlertModalOpen}
        onClose={() => setIsAlertModalOpen(false)}
        title="ส่งไปยังสินค้าหลุดจำนำ"
        message="ระบบจะทำการส่งสินค้าไปเมนูหลุดจำนำ"
        onConfirm={() => {
          setIsAlertModalOpen(false);
          updateOrder(rowID);
        }}
        image={RepossessedImg}
      />
    </div>
  );
};

export default SellOnConsignmen;
